export default class FireStation {
  constructor(obj) {
    this.fdid = obj.fdid;
    this.fire_dept_name = obj.fire_dept_name;
    this.hq_addr1 = obj.hq_addr1;
    this.hq_addr2 = obj.hq_addr2;
    this.hq_city = obj.hq_city;
    this.hq_state = obj.hq_state;
    this.hq_zip = obj.hq_zip;
    this.mail_addr1 = obj.mail_addr1;
    this.mail_addr2 = obj.mail_addr2;
    this.mail_po_box = obj.mail_po_box;
    this.mail_city = obj.mail_city;
    this.mail_state = obj.mail_state;
    this.mail_zip = obj.mail_zip;
    this.county = obj.county;
    this.dept_type = obj.dept_type;
    this.organization_type = obj.organization_type;
    this.number_of_stations = obj.number_of_stations;
    this.active_firefighters_career = obj.active_firefighters_career;
    this.active_firefighters_volunteer = obj.active_firefighters_volunteer;
    this.active_firefighters_paid_per_call =
      obj.active_firefighters_paid_per_call;
    this.non_firefighting_civilian = obj.non_firefighting_civilian;
    this.non_firefighting_volunteer = obj.non_firefighting_volunteer;
    this.primary_agency_for_emergency_mgmt =
      obj.primary_agency_for_emergency_mgmt;
  }
}
